import { css } from 'styled-components'

export const transition1 = css`
  transition: 300ms;
`
